import * as React from 'react';
import { IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { CustomButton, ButtonType } from 'soprasteria-ui-library';
import { OrthodonticReferralResponseApi } from "../../../../api/OrthodonticReferralResponseApi";
import { useAuth } from '../../../../App';
import { OrthodonticReferralPatientViewingTable } from '../OrthodonticReferralTables/OrthodonticReferralPatientViewingTable';
import { OrthodonticReferralPatientViewModal } from '../OrthodonticReferralModals/OrthodonticReferralPatientViewModal';
import { UserContext, isInRole } from '../../../../contexts/UserContext';
import { ALLMÄNTANDVÅRDBAS, URVALSTANDLÄKAREBAS } from '../../../../utils/RoleConstants';
import { TREATMENT1_TYPEID } from "../../../../utils/OrthodonticReferralConstants";

interface IOrthodonticReferralInformation {
    orthodonticReferral: IOrthodonticReferral;
    orthodonticReferralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
}

export const OrthodonticReferralPatientViewing: React.FunctionComponent<IOrthodonticReferralInformation> = ({ orthodonticReferral, orthodonticReferralId, changeSuccessMessage, changeErrorMessage, getOrthodonticReferral }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralResponseApi(auth);
    const [isCreatingPatientViewing, setIsCreatingPatientViewing] = React.useState<boolean>(false);
    const [selectedOrthodonticReferralPatientViewingId, setSelectedOrthodonticReferralPatientViewingId] = React.useState<number>(0);
    const userInfo = React.useContext(UserContext);
    const hasRoleAllmantandvard = isInRole(ALLMÄNTANDVÅRDBAS, userInfo.roles ? userInfo.roles : []);
    const hasRoleKonsulttandläkare = isInRole(URVALSTANDLÄKAREBAS, userInfo.roles ? userInfo.roles : []);

    const createPatientViewing = () => {
        var createPatientViewing = window.confirm("Är du säker på att du vill begära att allmäntandläkaren kallar patienten till visning?");

        if (createPatientViewing) {
            setIsCreatingPatientViewing(true);
            api.createPatientViewing(orthodonticReferralId,
                () => {
                    getOrthodonticReferral(orthodonticReferralId, true);
                    changeSuccessMessage("Patienten har kallats till visning");
                },
                (error) => {
                    changeErrorMessage(error);
                },
                () => {
                    setIsCreatingPatientViewing(false);
                })
        }
    }

    const openPatientViewingModal = (orthodonticReferralPatientViewingId: number) => {
        setSelectedOrthodonticReferralPatientViewingId(orthodonticReferralPatientViewingId);
        document.getElementById("open-orthodontic-referral-patient-viewing-modal")?.click();
    }

    const render = (): boolean | undefined => {
        return orthodonticReferral.orthodonticReferralTypeId === TREATMENT1_TYPEID && (hasRoleKonsulttandläkare || (hasRoleAllmantandvard && orthodonticReferral.patientViewings && orthodonticReferral.patientViewings?.length > 0));
    }


    return (
        render() ?
            <>
                <div className="row readonly-less-margin">
                    <h5 className="col-6">Visning av patient</h5>
                    <div className="col-6 text text-right">
                        {
                            orthodonticReferral.canCreatePatientViewing ?
                                <CustomButton id="create-patient-viewing" isLoading={isCreatingPatientViewing} buttonText="Begär att allmäntandvård kallar patient till visning" buttonType={ButtonType.create} onClick={() => createPatientViewing()} />
                                : null
                        }
                    </div>
                </div>
                <div className="row readonly-less-margin">
                    <div className="col-12">
                        <OrthodonticReferralPatientViewingTable orthodonticReferral={orthodonticReferral} openOrthodonticReferralPatientViewingModal={openPatientViewingModal} />
                        <OrthodonticReferralPatientViewModal orthodonticReferralId={orthodonticReferral.orthodonticReferralId ?? 0}
                            getOrthodonticReferral={getOrthodonticReferral}
                            selectedOrthodonticReferralPatientViewingId={selectedOrthodonticReferralPatientViewingId}
                            changeSuccessMessage={changeSuccessMessage} />
                    </div>
                </div>
                <hr />
            </>
            : null
    )
}